<template>
  <div>
    <div class="header pb-8 pt-5 pt-lg-6 d-flex align-items-center profile-header"
      style="min-height: 600px; background-size: cover; background-position: center top;">
      <b-container fluid>
        <!-- Mask -->
        <span class="mask bg-gradient-info opacity-8"></span>
        <!-- Header container -->
        <b-container fluid class="d-flex align-items-center">
          <b-row>
            <b-col lg="7" md="10">
              <h1 class="display-2 text-white">Profil Lengkap</h1>
              <p class="text-white mt-0 mb-5">Ini adalah halaman profil Alumni. Anda dapat melihat detail profile lengkapnya </p>
              <!-- <a href="#!" class="btn btn-info">Perbaharui profil</a> -->
            </b-col>
          </b-row>
        </b-container>
      </b-container>
    </div>

    <b-container fluid class="mt--9">
      <b-row>
        <b-col xl="4" class="order-xl-2 mb-5">
          <b-card no-body class="card-profile" alt="Image placeholder" img-top>
            <b-row class="justify-content-center">
              <b-col lg="3" class="order-lg-2">
                <div class="card-profile-image">
                  <a href="#">
                    <b-img src="img/theme/team-4.jpg" rounded="circle" />
                  </a>
                </div>
              </b-col>
            </b-row>

            <b-card-header class="text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
            </b-card-header>

            <b-card-body class="pt-0">
              <b-row>
                <b-col>
                  <div class="card-profile-stats d-flex justify-content-center mt-md-5">
                  </div>
                </b-col>
              </b-row>
              <div class="text-center mt-3">
                <h5 class="h3">
                  Jessica Jones<span class="font-weight-light">, 27</span>
                </h5>
                <div class="h5 font-weight-300">
                  <i class="ni location_pin mr-2"></i>Bucharest, Romania
                </div>
                <hr class="my-4">
                <div class="h5 mt-4">
                  <i class="ni business_briefcase-24 mr-2"></i>Solution Manager - Creative Tim Officer
                </div>
                <div>
                  <i class="ni education_hat mr-2"></i>University of Computer Science
                </div>

              </div>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col xl="8" class="order-xl-1">
          <card>
            <b-row align-v="center" slot="header">
              <b-col cols="8">
                <h3 class="mb-0">Edit profil </h3>
              </b-col>
            </b-row>

            <b-form @submit.prevent="updateProfile">
              <h6 class="heading-small text-muted mb-4">User information</h6>

              <div class="pl-lg-4">
                  <b-row>
                  <b-col lg="6">
                    <base-input type="text" label="Nama Depan" placeholder="Nama Depan" name="firstName" v-model="user.firstName" v-validate="'required'">
                    </base-input>
                    <div v-if="errors.has('firstName')" class="alert alert-danger rounded mb-3" role="alert">
                      Nama depan wajib diisi!
                    </div>
                  </b-col>

                  <b-col lg="6">
                    <base-input type="text" label="Nama Belakang" placeholder="Nama Belakang" name="lastName" v-model="user.lastName" v-validate="'required'">
                    </base-input>
                    <div v-if="errors.has('lastName')" class="alert alert-danger rounded mb-3" role="alert">
                      Nama belakang wajib diisi!
                    </div>
                  </b-col>

                </b-row>
                <b-row>
                  <b-col lg="6">
                    <base-input type="number" label="NPM" placeholder="NPM" name="npm" v-model="user.npm" v-validate="'required'">
                    </base-input>
                    <div v-if="errors.has('npm')" class="alert alert-danger rounded mb-3" role="alert">
                      NPM wajib diisi!
                    </div>
                  </b-col>

                  <b-col lg="6">
                    <base-input type="email" label="Email" placeholder="Email" name="email" v-model="user.email" v-validate="'required'">
                    </base-input>
                    <div v-if="errors.has('email')" class="alert alert-danger rounded mb-3" role="alert">
                      Email wajib diisi!
                    </div>
                  </b-col>
                </b-row>
              </div>
              <hr class="my-4">

              <!-- Address -->
              <h6 class="heading-small text-muted mb-4">Contact information</h6>

              <div class="pl-lg-4">
                <b-row>
                  <b-col md="12">
                    <base-input type="text" label="Address" placeholder="Home Address" v-model="user.address">
                    </base-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="4">
                    <base-input type="text" label="City" placeholder="City" v-model="user.city">
                    </base-input>
                  </b-col>
                  <b-col lg="4">
                    <base-input type="text" label="Country" placeholder="Country" v-model="user.country">
                    </base-input>
                  </b-col>
                  <b-col lg="4">
                    <base-input label="Postal Code" placeholder="ZIP Code" v-model="user.postalCode">
                    </base-input>
                  </b-col>
                </b-row>
              </div>

              <hr class="my-4">
              <!-- Description -->
              <h6 class="heading-small text-muted mb-4">About me</h6>
              <div class="pl-lg-4">
                <b-form-group label="About Me" label-class="form-control-label" class="mb-0"
                  label-for="about-form-textaria">
                  <!--  <label class="form-control-label">About Me</label> -->
                  <b-form-textarea rows="4" value="A beautiful premium dashboard for BootstrapVue."
                    id="about-form-textaria" placeholder="A few words about you ..."></b-form-textarea>
                </b-form-group>
              </div>
              <b-col cols="12 mt-4" class="text-right">
                <button class="btn btn-sm btn-primary">Perbaharui</button>
              </b-col>
            </b-form>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import DataService from '@/services/data.service';

export default {
  data() {
    return {
      user: {
        company: 'Creative Code Inc.',
        username: 'michael23',
        email: '',
        firstName: 'Mike',
        lastName: 'Andrew',
        address: 'Bld Mihail Kogalniceanu, nr. 8 Bl 1, Sc 1, Ap 09',
        city: 'New York',
        country: 'USA',
        postalCode: '',
        aboutMe: `Lamborghini Mercy, Your chick she so thirsty, I'm in that two seat Lambo.`
      }
    };
  },
  methods: {
    updateProfile() {
      alert('Your data: ' + JSON.stringify(this.user));
    }
  }
};
</script>
<style></style>
